export enum LINKER_MODEL_IDS {
  GOOGLE_DRIVE = 'trr-gdrive',
  SHAREPOINT = 'trr-sharepoint',
  CONFLUENCE = 'trr-confluence-dms',
  NOTION = 'trr-notion',
}

export enum LINKER_LABELS {
  GOOGLE_DRIVE = 'Google Drive',
  SHAREPOINT = 'SharePoint',
  CONFLUENCE = 'Confluence',
  NOTION = 'Notion',
}

export const LinkerModelIdToLabel = Object.freeze({
  [LINKER_MODEL_IDS.GOOGLE_DRIVE]: LINKER_LABELS.GOOGLE_DRIVE,
  [LINKER_MODEL_IDS.SHAREPOINT]: LINKER_LABELS.SHAREPOINT,
  [LINKER_MODEL_IDS.CONFLUENCE]: LINKER_LABELS.CONFLUENCE,
  [LINKER_MODEL_IDS.NOTION]: LINKER_LABELS.NOTION,
})

export type StateType = {
  loaded: boolean
  error: boolean
}

export type Source = 'Evidence' | 'Policy'

export interface ExtendedDocumentObject extends google.picker.DocumentObject {
  sizeBytes?: number
  caption?: string
}
